import { render, staticRenderFns } from "./ZyroPill.vue?vue&type=template&id=2ac5b00d&scoped=true&"
import script from "./ZyroPill.vue?vue&type=script&lang=js&"
export * from "./ZyroPill.vue?vue&type=script&lang=js&"
import style0 from "./ZyroPill.vue?vue&type=style&index=0&id=2ac5b00d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac5b00d",
  null
  
)

export default component.exports